<template>
  <!-- , 'has-mutirao': showMutirao -->
  <div class="main-img imgTab" :class="{'dnh-ia-advanced': !hasIaAdvancedFunctions}" v-loader.opacity.tab="loading">
    <div class="">
      <div v-if="false" class="toolbar"> <!-- FENANDO: REMOVIDO TEMPORARIAMENTE -->
        <label for="">{{ $t('selectPicker.filter') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckAnterior" autocomplete="off" @change="doFilter('anterior')"/>
        <label class="btn btn-outline-secondary" for="btnCheckAnterior">{{ $t('imageType.anterior') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckColor" autocomplete="off" @change="doFilter('color')"/>
        <label class="btn btn-outline-secondary" for="btnCheckColor">{{ $t('imageType.color') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckRedfree" autocomplete="off" @change="doFilter('redfree')"/>
        <label class="btn btn-outline-secondary" for="btnCheckRedfree">{{ $t('imageType.redfree') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckHeatmap" autocomplete="off" @change="doFilter('heatmap')"/>
        <label class="btn btn-outline-secondary" for="btnCheckHeatmap">{{ $t('imageType.heatmap') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckCustom" autocomplete="off" @change="doFilter('custom')"/>
        <label class="btn btn-outline-secondary" for="btnCheckCustom">{{ $t('imageType.custom') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckTexture" autocomplete="off" @change="doFilter('texture')"/>
        <label class="btn btn-outline-secondary" for="btnCheckTexture">{{ $t('imageType.texture') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckPanoramic" autocomplete="off" @change="doFilter('panoramic')"/>
        <label class="btn btn-outline-secondary" for="btnCheckPanoramic">{{ $t('imageType.panoramic') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckVideo" autocomplete="off" @change="doFilter('video')"/>
        <label class="btn btn-outline-secondary" for="btnCheckVideo">{{ $t('imageType.video') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckStereo" autocomplete="off" @change="doFilter('stereo')"/>
        <label class="btn btn-outline-secondary" for="btnCheckStereo">{{ $t('imageType.stereo') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckStereoImage" autocomplete="off" @change="doFilter('stereo_image')"/>
        <label class="btn btn-outline-secondary" for="btnCheckStereoImage">{{ $t('imageType.stereo_image') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckStereoVideo" autocomplete="off" @change="doFilter('stereo_video')"/>
        <label class="btn btn-outline-secondary" for="btnCheckStereoVideo">{{ $t('imageType.stereo_video') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckProgressionImage" autocomplete="off" @change="doFilter('progression_image')"/>
        <label class="btn btn-outline-secondary" for="btnCheckProgressionImage">{{ $t('imageType.progression_image') }}</label>

        <input type="checkbox" class="btn-check" id="btnCheckProgressionVideo" autocomplete="off" @change="doFilter('progression_video')"/>
        <label class="btn btn-outline-secondary" for="btnCheckProgressionVideo">{{ $t('imageType.progression_video') }}</label>
      </div>

      <!-- <div v-if="alert.message" class="alert alert-dismissible fade show" :class="alert.class" role="alert">
        <span v-html="alert.message"></span>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="clearMessage"></button>
      </div> -->

      <div class="no-results-box" v-if="alert.message">
        <BaseNoResults :title="alert.title" :text="alert.message"/>
      </div>

      <div class="scrollbar" v-if="filteredExamImages.length">
        <div class="action-box">
          <div v-if="showMutirao">
            <ExamImagePreAnalysis v-if="exam" :patient="patient" :exam="exam" @alertmsg="setAlert"/>
          </div>
        </div>

        <lightgallery-vue
          class="image-info-box grid-wrap-between ease-all" ref="lGallery" id="lightgallery"
          :settings="lightGallerySettings" :onInit="onInit" :onBeforeSlide="removeDownloadButton" :onAfterOpen="extraCustomization">
          <template v-for="(item, index) in filteredExamImages" :key="index">

            <a v-if="item.type.endsWith('VIDEO')" onclick="return false" class="thumbnail-box loading-eye lg-item" :class="item.type" :key="`video_${index}`" data-lg-size="1280-720"
              :data-video="getVideoSource(item)" data-download-url="" data-sub-html="<h4></h4><p></p>" :data-test="`anchorVideo_${index}`"
              @mouseenter="onVideoHoverStart(index)" @mouseleave="onVideoHoverEnd(index)">
              <video v-if="playingVideoIndex === index" class="lg-selector ease-all hover-preview-video thumbnail-media" :class="{ 'eyer2-image': item.eyerVersion > 0 }" :src="`${dataPath}/${item.name}`" :ref="el => playHoverVideo(el)" autoplay muted loop playsinline></video>
              <img class="lg-selector ease-all thumbnail-media" :src="thumbVideoPath ? `${thumbVideoPath}/${item.name}` : require('@/assets/images/default-video2.png')" loading="lazy" decoding="async" alt="video_thumb" @load="removeLoading($event)" @error="thumbVideoPath && handleThumbError($event, item)"/>

              <div class="image-badge" v-if="item.imageLaterality">
                <p class="image-badge__laterality">
                  {{ item.imageLaterality === 'R' ? $t('od') : $t('os') }}
                </p>
              </div>

              <div class="dropdown">
                <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" @click.stop.prevent>
                  <IconDot class="icon-dot" />
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li v-if="isPowerfull">
                    <a class="dropdown-item" :data-test="`btnOpenModalDeleteVideo_${index}`" @click.stop.prevent="openModalDelete(item.id)">
                      <IconTrash />
                      {{ $t('remove') }}
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" :data-test="`btnDownloadVideo_${index}`" @click.stop.prevent="doDownload(item, item.type.endsWith('VIDEO'))">
                      <IconDownload/>
                      {{ $t('download') }}
                    </a>
                  </li>
                  <!-- <li>
                    <a class="dropdown-item" data-test="btnAddDownloadExamDropdown" @click="openOffcanvasExamDownload">
                      <IconLaterality/>
                      {{ $t('examImages.laterality') }}
                    </a>
                  </li> -->
                </ul>
              </div>

              <div class="icon-video">
                <i class="fa fa-play-circle-o"></i>
              </div>
            </a>

            <a v-else class="thumbnail-box loading-eye lg-item" onclick="return false" :class="item.type" :data-laterality="item.imageLaterality || null" :href="dataPath + '/' + item.name" :key="`image_${index}`" :data-test="`anchorImage_${index}`">
              <img class="lg-selector ease-all thumbnail-media"
                   :class="{ 'eyer2-image': item.eyerVersion > 0 }"
                   :src="thumbDataPath +'/'+ item.name" :id="item.name"
                   loading="lazy" decoding="async" alt=""
                   @load="removeLoading($event)"
                   @error="$utils.enableDownloadOnError($event, item, doDownload)"/>
              <IconDownload class="thumbnail-not-found-icon"/>

              <div class="image-badge">
                <span class="image-badge__ai-status" v-if="hasTypeStatusBadge(item.type)" :class="computeImageAiClass(item)"></span>

                <p class="image-badge__laterality" v-if="item.imageLaterality">
                  {{ item.imageLaterality === 'R' ? $t('od') : $t('os') }}
                </p>

                <!-- eyerMaps' own "AI" pill — parked here (v-if false, not deleted) until it's
                     redesigned into the same dot-in-front-of-laterality scheme as the rest -->
                <p class="image-badge__ai" v-if="false">
                  AI
                  <span class="image-badge__ai-status" :class="computeImageAiClass(item)"></span>
                </p>

                <p class="image-badge__type" v-if="item.type !== 'FFA'">
                  {{ badgeTypeLabel(item.type) }}
                </p>

                <p class="image-badge__ffa" v-if="item.type === 'FFA'">
                  {{ badgeTypeLabel(item.type) }}
                  <IconClock/>
                  {{ formatFaElapsedTime(item) }}
                </p>
              </div>

              <BaseFeature feature="iaAdvancedFunctions">
                <div class="checkbox" v-show="allowEdition(item.type)">
                  <BaseRoundedCheckBox :id="item.name" :item="item" @checked="doCheck"/>
                </div>
              </BaseFeature>

              <div class="dropdown">
                <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" @click.stop.prevent>
                  <IconDot class="icon-dot" />
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li v-if="isPowerfull">
                    <a class="dropdown-item" :data-test="`btnOpenModalDeleteImage_${index}`" @click.stop.prevent="openModalDelete(item.id)">
                      <IconTrash />
                      {{ $t('remove') }}
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" :data-test="`btnDownloadImage_${index}`" @click.stop.prevent="doDownload(item, item.type == 'STEREO')">
                      <IconDownload/>
                      {{ $t('download') }}
                    </a>
                  </li>
                  <BaseFeature feature="iaAdvancedFunctions">
                    <li>
                      <a class="dropdown-item" :data-test="`btnEditImage_${index}`" @click.stop.prevent="doEdit(item)" v-if="allowEdition(item.type)">
                        <i class="fa fa-edit"></i>
                        {{ $t('edit') }}
                      </a>
                    </li>
                  </BaseFeature>
                  <li v-if="canSwitchLaterality(item)">
                    <a class="dropdown-item" data-test="btnToggleLaterality" @click.stop.prevent="openConfirmLateralitySwitchOffcanvas(item)">
                      <IconLaterality/>
                      {{ $t('examImages.laterality') }}
                    </a>
                  </li>
                </ul>
              </div>
            </a>
          </template>
        </lightgallery-vue>
      </div>
    </div>

    <div class="action-bar" @wheel.prevent>
      <BaseFeature feature="iaAdvancedFunctions">
        <label for="">{{ $t('aipo') }}</label>
        <button class="btn btn-success" :class="{'disabled': !isValidForHeatmap}" type="button" name="button" data-test="btnFunctionHeatmap" @click="openOffcanvasGeneric('heatmap')">{{ $t('imageType.heatmap') }}</button>
        <button class="btn btn-success" :class="{'disabled': selectedImages.length < 2}" type="button" name="button" data-test="btnFunctionPanoramic" @click="openOffcanvasGeneric('panoramic')">{{ $t('imageType.panoramic') }}</button>
        <button class="btn btn-success" :class="{'disabled': selectedImages.length < 2}" type="button" name="button" data-test="btnFunctionStereo" @click="openOffcanvasGeneric('stereo')">{{ $t('imageType.stereo') }}</button>
      </BaseFeature>

      <!-- <button class="btn btn-outline-success connector-send-btn" type="button" name="button" data-test="btnConnectorSend"
              :class="{'disabled': !selectedImages.length}" @click="openConnectorSend">
        <i class="fa fa-paper-plane"></i>
        <span>{{ $t('connectorSend.action') }}</span>
      </button> -->
    </div>

    <teleport to="body">
      <BaseCropperModal ref="modalCropper"/>

      <BaseGenericModal :modal_id="'modalImageGeneric'" ref="modalGeneric"/>
      <BaseGenericOffcanvas :offcanvas_id="'offcanvasDeleteGeneric'" ref="offcanvasGeneric"/>
      <BaseCropperOffcanvas :offcanvas_id="'offcanvasCropper'" ref="offcanvasCropper"/>

      <BasePatientAccessInfoModal :patient="patient" v-if="showAccessInfoModal" @close="showAccessInfoModal = false"/>

      <!-- <ExamConnectorSendOffcanvas ref="connectorSendOffcanvas" /> -->
    </teleport>
  </div>
</template>

<style lang="scss" scoped>
.icon-video {
  color:                              #B5B5B5;
  font-size:                          20px;
  font-weight:                        normal !important;
  line-height:                        1;
  position:                           absolute;
  top:                                8px;
  right:                              8px;
  z-index:                            100;
  pointer-events:                     none;
}

.btn-check:checked + .btn {
  color:                               var(--Brand-Secondary) !important;
  background:                          #CAF1E6 !important;
  border:                              1px solid var(--Brand-Secondary) !important;
}

.main-img {
  > div:first-child {
    padding:                           10px;
  }

  .scrollbar {
    flex:                              1;
    min-height:                        0;
    width:                             100%;
    padding-right:                     10px;
    overflow-y:                        auto;
  }

  .toolbar {
    display:                           flex;
    justify-content:                   flex-start;
    align-items:                       center;
    flex-wrap:                         wrap;
    gap:                               10px;
    margin-bottom:                     10px;

    label {
      color:                            var(--Shades-70);
      font-size:                        var(--font-size-12);
      font-weight:                      400;
      line-height:                      normal;
      letter-spacing:                   1.8px;
      text-transform:                   uppercase;
    }

    .btn {
      color:                            var(--Shades-70);
      font-size:                        var(--font-size-12);
      font-weight:                      400;
      line-height:                      normal;
      letter-spacing:                   1.8px;
      text-overflow:                    ellipsis;
      overflow:                         hidden;
      gap:                              5px;
      padding:                          10px 17px;
      background:                       var(--Shades-10);
      border:                           1px solid var(--Shades-30);
    }
  }

  .thumbnail-box {
    @include                            border_radius(11.898px);
    aspect-ratio:                       87 / 74;
    position:                           relative;


    .thumbnail-not-found-icon {
      display:                          none;
    }

    &.image-failed {
      .thumbnail-not-found-icon {
        display:                        block;
        position:                       absolute;
        top:                            50%;
        left:                           50%;
        transform:                      translate(-50%, -50%);
        width:                          28px;
        height:                         28px;
        pointer-events:                 none;
        z-index:                        99;
      }

      .thumb-actions {
        display:                        none !important;
      }
    }
  }
}

.action-bar {
  label {
    color:                              var(--Shades-70);
    font-size:                          var(--font-size-12);
    font-weight:                        400;
    line-height:                        normal;
    letter-spacing:                     1.8px;
    text-transform:                     uppercase;
  }
}

.retract {
  .main-img {
    &.dnh-ia-advanced {
      .action-bar {
        display:                        none;
      }
    }
  }
}

.image-info-box {
  &.grid-wrap-between {
    align-items:                        flex-start !important;
    height:                             auto;
  }
}

@media (max-width: 480px) {
  .main-img {
    .text-end.mb-2, .toolbar {
      text-align:                       center !important;
    }
    .toolbar {
      .filters {
        max-width:                      100% !important;
      }
      &, .btn-group {
        display:                        block;
      }
    }
  }

  .retract .image-info-box.grid-wrap-between,
  .image-info-box.grid-wrap-between {
    grid-template-columns:              repeat(auto-fill, 100%) !important;
  }
}

@media screen and (min-width: 481px) and (max-width: 767px) {
  .main-img {
    .toolbar {
      .filters, .btn-group {
        display:                        inline-block;
      }
      .btn-group {
        text-align:                     right;
      }
    }
  }
}

@media (max-width: 767px) {
  .main-img {
    .toolbar {
      margin-bottom:                    10px;
      span {
        margin-right:                   10px;
      }
      .filters,
      .btn-group {
        margin-bottom:                  10px;
      }
    }
  }
}

@media screen and (min-width: 481px) and (max-width: 991px) {
  .retract .image-info-box.grid-wrap-between,
  .image-info-box.grid-wrap-between {
    grid-template-columns:              repeat(auto-fill, 48%) !important;
  }
}

@media (min-width: 992px) {
  // .main-img:not(.dnh-ia-advanced) > div:first-child {
  //   flex: unset; // removed: now flex: 1 applies to all cases for proper scroll
  // }
}

@media (max-width: 1199px) {
  .main-img {
    .action-box {
      > div {
        width:                          auto;
      }
    }
    .bootstrap-select.show-tick.bs3 {
      margin-bottom:                    0;
    }
  }
}

@media (max-width: 991px) {
  .main-img {
    height:                             100%;

    > div:first-child {
      display:                          flex;
      height:                           calc(100% - 6px);
      // height:                           calc(100% - 83px);
      padding-right:                    0;
    }

    .no-results-box {
      text-align:                       center;
    }

    .toolbar {
      display:                          flex;
      flex-direction:                   row;
      flex-wrap:                        nowrap;
      justify-content:                  flex-start;
      align-items:                      center;
      gap:                              10px;
      overflow-x:                       scroll;
      margin:                           -10px 0 0 0;
      padding:                          0 10px 10px 10px;
      border-bottom:                    1px solid var(--Shades-20, #F0F0F0);

      &::-webkit-scrollbar {
        display:                        none;
      }

      .btn {
        overflow:                       unset;
        white-space:                    nowrap;
      }
    }
  }

  .main-img,
  .retract {
    .main-img {
      .scrollbar {
        max-height:                     calc(100dvh - 299px) !important;
      }

      &.dnh-ia-advanced {
        .scrollbar {
          max-height:                   calc(100dvh - 200px) !important;
        }
      }

      &.has-mutirao {
        .scrollbar {
          max-height:                   calc(100dvh - 200px) !important;
        }
      }
    }
  }

  .has-alert,
  .has-alert .retract {
    .main-img {
      &.dnh-ia-advanced {
        .scrollbar {
          max-height:                   calc(100dvh - 284px) !important;
        }
      }
    }
  }
}
</style>

<script src="./ExamImageTab.js"></script>
